<div class="d-flex flex-column w-100">
  <app-polly-manage-application-header [appHeaderName]="appHeader" (closeEvent)="closeTheRunningInstance()">
    <div *ngIf="isShinyApp" class="pr-5" slot="header-actions">
      <p-select [options]="versionNames" [(ngModel)]="selectedVersion" optionLabel="viewValue"
        (onChange)="onValueChange($event.value)" placeholder="Select a state to restore" #stateDropdown id="stateDropdown"
        [panelStyleClass]="'qubit size-small'" [styleClass]="'qubit size-small'" dropdownIcon="polly-icon caret-down" >
        <ng-template let-version pTemplate="item">
          <div [pTooltip]="version.viewValue" tooltipPosition="left">{{ version.viewValue }}</div>
        </ng-template>
      </p-select>
    </div>
  </app-polly-manage-application-header>
  <section id="iframe-section" class="iframe-container">
    @if(iframeLoadError){
    <div class="d-flex justify-content-between align-items-center">
      <p class="iframe-error">Unable to load the application. Please try again later.</p>
    </div>
    } @else {
    <iframe id="iframeShiny" [src]="appUrl | safe : 'resourceUrl'" (load)="onIframeLoad()"
      (error)="onIframeError()" width="100%" height="100%" frameborder="0" class="iframe-shiny">
    </iframe>
    }
  </section>
</div>
